import React, { useEffect, useState } from "react";

import HeaderNomal from "../components/HeaderNormal"
import Footer from '../components/Footer'
import '../styles/Charter.css'


const Charter = () => {
  return (
    <>
    <HeaderNomal />
    <section className="charter-section">
      <div className="charter-content">
        <h2>Charter : Naviguez en toute liberté</h2>
        <p>
          Que vous soyez passionné de croisière ou simplement à la recherche d'une expérience unique en mer,
          Nous avons sélectionné des voiliers performant avec ou sans skipper. 
          <br />
          Profitez d’un moment de détente, de découverte et d’aventure, en toute sérénité.
        </p>
        <p>
          Pour vos envies d’évasion, découvrez notre partenaire spécialisé :
          <a
            href="https://sailing-dream-experience.com/fr"
            target="_blank"
            rel="noopener noreferrer"
            className="charter-link"
          >
            Sailing Dream Experience
          </a>
        </p>
      </div>
    </section>
    <Footer />
    </>
  );
};

export default Charter;
